import React, { useState } from "react";
import {
    FaBox,
    FaUser,
    FaUserLock,
    FaTag,
    FaPuzzlePiece,
    FaNewspaper,
    FaSignOutAlt,
    FaHome,
    FaBars,
    FaCogs,
} from "react-icons/fa";
import { NavLink } from "react-router-dom";

import Aside from "../Aside";
import {
    ADMIN_ROLE_ID,
    OPERATIONAL_ROLE_ID,
    hasRoleAccess,
} from "../../../service/authorization";

const Index = () => {
    const [navVisible, setNavVisible] = useState("navNotVisible");
    const canAccessAdminOnly = hasRoleAccess([ADMIN_ROLE_ID]);
    const canAccessOperational = hasRoleAccess([
        ADMIN_ROLE_ID,
        OPERATIONAL_ROLE_ID,
    ]);

    return (
        <Aside>
            <div
                className="toggle-menu cursor-pointer"
                onClick={() => {
                    if (navVisible === "navNotVisible") {
                        return setNavVisible("navVisible");
                    }

                    return setNavVisible("navNotVisible");
                }}
            >
                <FaBars />
                <span>Menu</span>
            </div>
            <nav className={navVisible}>
                <NavLink to="/ctop/home">
                    <FaHome />
                    <span>Home</span>
                </NavLink>

                {canAccessOperational && (
                    <NavLink to="/ctop/produtos">
                        <FaBox />
                        <span>Produtos</span>
                    </NavLink>
                )}

                {canAccessOperational && (
                    <NavLink to="/ctop/clientes">
                        <FaUser />
                        <span>Clientes</span>
                    </NavLink>
                )}

                {canAccessAdminOnly && (
                    <NavLink to="/ctop/noticias">
                        <FaNewspaper />
                        <span>Noticias</span>
                    </NavLink>
                )}

                {canAccessAdminOnly && (
                    <NavLink to="/ctop/produtos/aplicacoes">
                        <FaPuzzlePiece />
                        <span>Aplicações</span>
                    </NavLink>
                )}

                {canAccessAdminOnly && (
                    <NavLink to="/ctop/produtos/linhas">
                        <FaTag />
                        <span>Linhas</span>
                    </NavLink>
                )}

                {canAccessAdminOnly && (
                    <NavLink to="/ctop/usuarios">
                        <FaUserLock />
                        <span>Usuários</span>
                    </NavLink>
                )}

                {canAccessAdminOnly && (
                    <NavLink to="/ctop/settings">
                        <FaCogs />
                        <span>Configurações</span>
                    </NavLink>
                )}

                <NavLink to="/ctop">
                    <FaSignOutAlt />
                    <span>Sair</span>
                </NavLink>
            </nav>
        </Aside>
    );
};

export default Index;
